import { noop } from 'lodash';
import { createContext, useContext } from 'react';

import { IPartFinderSelection } from 'partFinder/types';
import { EMPTY_SELECTION } from 'partFinder/utils';

interface ICatalogContext {
  // The catalog's stock and location narrowing, which the family page inherits.
  selection: IPartFinderSelection;
  returnTo?: string;
  onOpenFamily: (familyId: number) => void;
}

// The grid cells read the catalog's state from here instead of from cellRendererParams, so the
// column definitions stay the same while the filters change - new definitions would make the
// layout hook re-apply the saved layout and reset the column sizes the user has set.
export const CatalogContext = createContext<ICatalogContext>({
  selection: EMPTY_SELECTION,
  onOpenFamily: noop,
});

export const useCatalogContext = () => useContext(CatalogContext);
